<h1 class="heading">{{ params.heading }}</h1>
<div class="text">
  {{ params.subHeading }}<br />
  <span class="email-text">{{ email }}</span>
</div>

<ng-container *ngIf="totalCheckoutValue">
  <div class="checkout-details">
    <hr class="details-divider" />
    <div class="checkout-item">
      <p>Gesamtbetrag</p>
      <p>{{ totalCheckoutValue | value }}</p>
    </div>

    <hr class="details-divider" />
    <div class="checkout-item">
      <p>Zahlungsmethode</p>
      <p>Monatsrechnung</p>
    </div>
    <hr class="details-divider" />
  </div>

  <zaver-button-link
    class="details-link"
    (click)="detailsClick()"
    [text]="'Details und Bedingungen ansehen'"
  ></zaver-button-link>
</ng-container>
